// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 3C0.895431 3 0 3.89543 0 5V18C0 19.1046 0.89543 20 2 20H2.58579L2.08579 20.5L3.5 21.9142L5.41421 20H8V12H2V5H13V7H15V5C15 3.89543 14.1046 3 13 3H2ZM3 15H5.00391V17.0039H3V15Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.677 8H11.323L9 13.8074V21.5H11V20H22V21.5H24V13.8074L21.677 8ZM21.123 12H11.877L12.677 10H20.323L21.123 12ZM12 15H14.0039V17.0039H12V15ZM21.0039 15V17.0039H19V15H21.0039Z"}}]};

const VehicleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'vehicle-filled',
    ref,
    icon: element,
  },
));

VehicleFilledIcon.displayName = 'VehicleFilledIcon';

export default VehicleFilledIcon;
